import { ButtonEnum } from "designSystem/types/button-types";
import Widget from "csi/wizard/Widget";
import declare from "dojo/_base/declare";

const {
	BUTTON_SAVE,
	BUTTON_SAVE_NEW,
	BUTTON_FINISH,
	BUTTON_NEXT_PAGE,
} = ButtonEnum;

const NewBOMLineItemWizard = declare(Widget, {

	/**
	 * @override
	 * Add extra check for disabling Save button on second page of wizard
	 * if no selections are made
	 */
	canEnableButton: function(button, idAction) {
		var page = this.getSelectedPage();
		var index = this.getIndexOfPage(page);

		if (idAction === BUTTON_SAVE) {
			return !this.disableSave(page, index);
		}

		return this.inherited(arguments);
	},

	/**
	 * @override
	 * Add Save New button to wizard and remove Finish button
	 */
	canShowButton(idAction) {
		const page = this.getSelectedPage();
		const index = this.getIndexOfPage(page);

		if (idAction === BUTTON_FINISH) {
			return false;
		}

		if (idAction === BUTTON_SAVE_NEW || idAction === BUTTON_NEXT_PAGE) {
			return index === 0;
		}

		return this.inherited(arguments);
	},

	/**
	 * Disable Save button if if no selections are made on selection page
	 */
	disableSave(page, index) {
		// needs more logic for selection. Maybe it comes from page argument
		const view = page.getView();
		const formData = view.defView.getFormData();
		if (index > 0 && !formData.hasSelections()) {
			return true;
		}
		return false;
	},
});

export = NewBOMLineItemWizard;